import { UTM_COOKIE_MAP, UTM_MARKS } from 'constants/utmMarks';

import { readUtmCookie } from './readUtmCookie';

export const getUtmMarksFromCookie = (ctx: App.ReduxAppContext['ctx']) => {
  const cookieValue = readUtmCookie(ctx);

  const parsed = (cookieValue.split('|') || []).reduce<Record<string, string>>((output, item) => {
    const [name, value] = item.split('=');
    if (value) {
      output[name] = value;
    }
    return output;
  }, {});

  return Object.values(UTM_MARKS).reduce<Record<string, string>>((prev, name) => {
    const value = parsed[UTM_COOKIE_MAP[name]];
    if (value) {
      prev[name] = value;
    } else {
      prev[name] = UTM_MARKS.medium === name ? '(none)' : '(not set)';
    }
    return prev;
  }, {});
};
